import { NSABoxSecret, NSARouterMakerResult } from "namirasoft-account-react";
import { EncodingOperation } from "namirasoft-core";
import { UserFullRow } from "namirasoft-password";
import { EncryptionOperation, IBaseComponentProps, INSBox, INSBoxBaseLayoutProps, IValidationProps, IValidationStringProps } from "namirasoft-site-react";
import React, { createRef, HTMLInputAutoCompleteAttribute } from "react";
import { Storage } from "../Storage";

export interface NSBoxPasswordProps extends IBaseComponentProps, IValidationProps, IValidationStringProps, NSARouterMakerResult, INSBoxBaseLayoutProps<NSBoxPassword, string>
{
    user: UserFullRow;
    input?: IBaseComponentProps;
    auto_complete?: HTMLInputAutoCompleteAttribute | undefined;
    onSensitiveChange?: (sensitive: boolean) => void
}

export class NSBoxPassword extends React.Component<NSBoxPasswordProps> implements INSBox
{
    private NSABoxSecret_Main = createRef<NSABoxSecret>();

    constructor(props: NSBoxPasswordProps)
    {
        super(props);
        this.state = {
            value: null,
        };
        this.isEmpty = this.isEmpty.bind(this);
        this.getError = this.getError.bind(this);
        this.isSensitive = this.isSensitive.bind(this);
        this.setSensitive = this.setSensitive.bind(this);
        this.getValue = this.getValue.bind(this);
        this.setValue = this.setValue.bind(this);
        this.setEncryptedValue = this.setEncryptedValue.bind(this);
        this.getEncryptedValue = this.getEncryptedValue.bind(this);
    }

    isEmpty(value: string)
    {
        return this.NSABoxSecret_Main.current?.isEmpty(value) ?? true;
    }
    getError(): string | null
    {
        return this.NSABoxSecret_Main.current?.getError() ?? null;
    }
    isSensitive(): boolean
    {
        return this.NSABoxSecret_Main.current?.isSensitive() ?? false;
    }
    setSensitive(value: boolean, callback?: (() => void))
    {
        this.NSABoxSecret_Main.current?.setSensitive(value, callback);
    }
    getValue(checkError: boolean = true): string | null
    {
        return this.NSABoxSecret_Main.current?.getValue(checkError) ?? null;
    }
    setValue(value: string | null, callback?: () => void): void
    {
        this.NSABoxSecret_Main.current?.setValue(value, callback);
    }
    async getEncryptedValue(checkError: boolean = true): Promise<string | null>
    {
        return this.NSABoxSecret_Main.current?.getEncryptedValue(checkError) ?? null;
    }
    async setEncryptedValue(value: string | null, callback?: () => void)
    {
        this.NSABoxSecret_Main.current?.setEncryptedValue(value, callback);
    }
    setDisabled(disabled: boolean): void
    {
        this.NSABoxSecret_Main.current?.setDisabled(disabled);
    }
    override render()
    {
        return (
            <NSABoxSecret
                {...this.props}
                ref={this.NSABoxSecret_Main}
                sensitive_enabled={true}
                onChanged={() => this.props.onChanged?.(this)}
                onClicked={() => this.props.onClicked?.(this)}
                onSensitiveChange={(value) => this.props.onSensitiveChange?.(value)}
                encryption={{
                    encryptor: async (value) =>
                    {
                        return EncryptionOperation.AES256GCMEncrypt(await Storage.getMasterKey(this.props.user.id), EncodingOperation.Base64Encode(value));
                    },
                    decryptor: async (value) =>
                    {
                        return EncodingOperation.Base64Decode(await EncryptionOperation.AES256GCMDecrypt(await Storage.getMasterKey(this.props.user.id), value));
                    }
                }}
            />
        );
    }
}